/**
 * @flow
 * @relayHash 6871f86c7d55b831d77aff1b6fa7d361
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type InfoStringAddInput = {
  title: string,
  infostring?: ?boolean,
  infostring_hot?: ?boolean,
  order: number,
  clientMutationId?: ?string,
};
export type InfoStringAddMutationVariables = {|
  input: InfoStringAddInput
|};
export type InfoStringAddMutationResponse = {|
  +InfoStringAdd: ?{|
    +error: ?string,
    +infoStringEdge: ?{|
      +node: ?{|
        +id: string
      |}
    |},
  |}
|};
export type InfoStringAddMutation = {|
  variables: InfoStringAddMutationVariables,
  response: InfoStringAddMutationResponse,
|};
*/


/*
mutation InfoStringAddMutation(
  $input: InfoStringAddInput!
) {
  InfoStringAdd(input: $input) {
    error
    infoStringEdge {
      node {
        id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "InfoStringAddInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "InfoStringAdd",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "InfoStringAddInput!"
      }
    ],
    "concreteType": "InfoStringAddPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "error",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "infoStringEdge",
        "storageKey": null,
        "args": null,
        "concreteType": "InfoStringEdge",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "InfoString",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "InfoStringAddMutation",
  "id": null,
  "text": "mutation InfoStringAddMutation(\n  $input: InfoStringAddInput!\n) {\n  InfoStringAdd(input: $input) {\n    error\n    infoStringEdge {\n      node {\n        id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "InfoStringAddMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "InfoStringAddMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '61456962919c57aa3564328d1c7d0464';
module.exports = node;



// WEBPACK FOOTER //
// src/mutations/__generated__/InfoStringAddMutation.graphql.js